export const P0003601ModelePompe = [
  { ref: '01020408', label: 'P0003601.modelePompe.1' },
  { ref: '00030509', label: 'P0003601.modelePompe.2' },
  { ref: '00020408', label: 'P0003601.modelePompe.3' },
];
